import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Toast } from 'primereact/toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

const TestimonialsAddEdit = () => {

    const { id } = useParams()
    const isEdit = id ? true : false
    const toast = useRef(null)
    const navigate = useNavigate()

    const numProps = (e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()

    const [testimonialsData, setTestimonialsData] = useState([])

    useEffect(() => {
        isEdit && getTestimonials()
    }, [])

    const schema = yup.object({
        testimonial: yup.string().required("Testimonial is required"),
        authorName: yup.string().required("Name is required"),
        company: yup.string().required("Company is required"),
        rating: yup.number().transform((value, originalValue) => (originalValue === "" || isNaN(originalValue)) ? null : value).nullable().required("Rating is required").max(5, "Value Must be less than or equal to 5"),
        authorPhotoUrl: yup.mixed().optional(),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, resetField, watch, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            testimonial: '',
            authorName: '',
            company: '',
            rating: '',
            authorPhotoUrl: null,
            isActive: '',
        })
    }

    const previewImage = watch('authorPhotoUrl')

    const getTestimonials = (data) => {
        ApiHelper.get(`${API_ENDPOINTS.TESTIMONIALS}/${id}`, data).then((res) => {
            if (res.status === 200) {
                setTestimonialsData(res.data.data)
                reset({
                    testimonial: res.data.data.testimonial,
                    authorName: res.data.data.authorName,
                    company: res.data.data.company,
                    rating: res.data.data.rating,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const onSubmit = (data) => {
        const formData = new FormData()
        for (const [key, value] of Object.entries(data)) {
            formData.append(key, value);
        };
        if (data.authorPhotoUrl) {
            formData.append('authorPhotoUrl', data.authorPhotoUrl[0]);
        }
        if (isEdit) {
            update(formData)
        } else {
            add(formData)
        }
    };

    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.TESTIMONIALS}/`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/testimonials')
                }, 1500)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.TESTIMONIALS}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/testimonials')
                }, 1500)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const confirmDeleteDailog = () => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteImage(),
        });
    };

    const deleteImage = () => {
        ApiHelper.post(`${API_ENDPOINTS.TESTIMONIALS}/delete-image/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getTestimonials();
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate(`/testimonials`)}> Testimonials </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                                </span>
                            </h4>
                            <Link to="/testimonials" class="btn btn-secondary">⬅ Go Back</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div class="row mb-3">
                                                <div class="col-md-2 mb-3">

                                                    <label class="form-label">Name</label>
                                                    <input type="text" name="authorName" class="form-control" {...register("authorName")} />
                                                    <small className="text-danger">{errors.authorName?.message}</small>
                                                </div>
                                                <div class="col-md-2 mb-3">
                                                    <label class="form-label">Company</label>
                                                    <input type="text" name="company" class="form-control" {...register("company")} />
                                                    <small className="text-danger">{errors.company?.message}</small>
                                                </div>
                                                <div class="col-md-2 mb-3">
                                                    <label class="form-label">Rating</label>
                                                    <input type="number" name="rating" onKeyDown={numProps} step='0.1' class="form-control" {...register("rating")} />
                                                    <small className="text-danger">{errors.rating?.message}</small>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label class="form-label">Review</label>
                                                    <textarea rows="4" type="text" name="testimonial" class="form-control" {...register("testimonial")} />
                                                    <small className="text-danger">{errors.testimonial?.message}</small>
                                                </div>
                                                {testimonialsData?.authorPhotoUrl ? (
                                                    <div class="col-md-3 mb-3">
                                                        <label class="form-label">Author Image</label>
                                                        <br />
                                                        <div class="mt-3">
                                                            <div class="d-inline-block ">
                                                                <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                    <a target="_blank">
                                                                        <img src={`${process.env.REACT_APP_BASE_URL}/${testimonialsData?.authorPhotoUrl}`} id="existingImagePhoto" class="img-thumbnail" />
                                                                    </a>
                                                                    <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => confirmDeleteDailog()}> &times; </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div class="col-md-3 mb-3">
                                                        <label class="form-label">Upload Author Image</label>
                                                        <br />
                                                        <div>
                                                            <input type="file" accept=".jpeg, .jpg, .png, .webp" name="authorPhotoUrl" {...register("authorPhotoUrl")} class="form-control" />
                                                        </div>
                                                        {previewImage?.[0] && (
                                                            <div class="mt-1">
                                                                <div class="d-inline-block ">
                                                                    <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                        <a target="_blank">
                                                                            <img src={URL.createObjectURL(previewImage[0])} id="existingImagePhoto" class="img-thumbnail" />
                                                                        </a>
                                                                        <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => resetField('authorPhotoUrl')}> &times; </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                                }
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Status</label>
                                                    <div class="form-check form-switch mb-2">
                                                        <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default TestimonialsAddEdit
